import { derived, writable } from "svelte/store";
import type { Component, ComponentType } from "svelte";
import {
  Activity,
  BriefcaseIcon,
  KeyRound,
  MapPinned,
  Settings,
  Wrench,
} from "lucide-svelte";
import CvrPage from "../pages/cvr.svelte";
import DevInfoPage from "../pages/dev-info.svelte";
import HangfirePage from "../pages/hangfire.svelte";
import SettingsPage from "../pages/settings.svelte";
import AutoItTestPage from "../pages/autoit-test.svelte";
import DealerMapPage from "../pages/dealer-map.svelte";

type PageBase = {
  id: string;
  label: string;
  icon?: ComponentType;
  component: Component;
};

const pages = [
  { id: "cvr", label: "CVR", icon: BriefcaseIcon, component: CvrPage },
  {
    id: "dealer-map",
    label: "Bilforhandlere",
    icon: MapPinned,
    component: DealerMapPage,
  },
  {
    id: "autoit-test",
    label: "AutoIT Test",
    icon: KeyRound,
    component: AutoItTestPage,
  },
  {
    id: "hangfire",
    label: "Hangfire",
    icon: Activity,
    component: HangfirePage,
  },
  {
    id: "settings",
    label: "Settings",
    icon: Settings,
    component: SettingsPage,
  },
  { id: "dev", label: "Dev info", icon: Wrench, component: DevInfoPage },
] as const satisfies ReadonlyArray<PageBase>;

export type PageDef = (typeof pages)[number];
export type PageId = PageDef["id"];

const defaultPageId = pages[0]!.id;

export const activePageId = writable<PageId>(defaultPageId);

export const activePageDef = derived(activePageId, ($activePageId) => {
  return (
    (pages as ReadonlyArray<PageDef>).find(
      (page) => page.id === $activePageId,
    ) ?? pages[0]!
  );
});

export { pages };
